
export default {
  '/': {
    tag: 'page-index',
  },
  // TODO: paypay対応され次第削除
  '/paypay/receive': {
    tag: 'page-paypay-receive',
  },
  '/receive': {
    tag: 'page-receive',
  },
  '/gift': {
    tag: 'page-distribution_events-single',
  },
  '/raffle': {
    tag: 'page-raffle_events-single',
  },
  '/thanks': {
    tag: 'page-thanks',
  },
  '/campaigns/:campaign_id/terms': {
    tag: 'page-terms',
  },
};
